import React from 'react'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'

/**
 * Temporary button component for testing
 *
 * TODO: Replace with ShadCn button component
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Button content
 * @param {'primary' | 'secondary' | 'tertiary'} [props.variant='primary'] - Button style variant
 * @param {'button' | 'submit' | 'reset'} [props.type='button'] - Button HTML type
 * @param {() => void} [props.onClick] - Click handler
 * @param {boolean} [props.disabled] - Whether button is disabled
 * @param {string} [props.className] - Additional CSS class names
 */
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'tertiary'
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export function Button({
  children,
  variant = 'primary',
  type = 'button',
  onClick,
  disabled = false,
  className = '',
  ...rest
}: ButtonProps): React.ReactElement {
  const variantClasses = {
    primary:
      'strata:bg-primary-500 strata:text-white strata:hover:bg-primary-600 strata:disabled:opacity-60',
    secondary:
      'strata:bg-gray-100 strata:text-gray-700 strata:border strata:border-gray-200 strata:hover:bg-gray-200 strata:disabled:opacity-60',
    tertiary:
      'strata:bg-transparent strata:text-information-accent strata:hover:bg-information-background strata:disabled:opacity-60',
  }

  return (
    <button
      type={type}
      className={cn(
        'strata:font-medium strata:rounded-xs strata:py-2 strata:px-4 strata:text-3.5 strata:cursor-pointer strata:transition-all strata:duration-200 strata:border-none strata:outline-none strata:inline-flex strata:items-center strata:justify-center strata:focus-visible:focus-strata strata:focus-visible:border-gray-400 strata:active:border-system-information-accent strata:active:outline-none strata:disabled:cursor-not-allowed',
        variantClasses[variant],
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
